/**
 * currentMusic 变化时 checkCacheStatus；playing 时轮询检查；监听 tenryu:cache-cleared 并重新检查
 * 抽离自 MusicPlayer.js
 */
import { useEffect } from 'react';

/**
 * @param {object} options
 * @param {object|null} options.currentMusic
 * @param {boolean} options.playing
 * @param {function(object): Promise<void>|void} options.checkCacheStatus
 * @param {function(boolean): void} options.setIsCached
 * @param {React.MutableRefObject<boolean>} options.wasCachedRef
 */
export function useCacheStatusOnMusic({
  currentMusic,
  playing,
  checkCacheStatus,
  setIsCached,
  wasCachedRef
}) {
  useEffect(() => {
    if (currentMusic) {
      wasCachedRef.current = false;
      checkCacheStatus(currentMusic);
    } else {
      setIsCached(false);
      wasCachedRef.current = false;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMusic?.id]);

  useEffect(() => {
    if (!playing || !currentMusic) return;

    const initialTimeout = setTimeout(() => {
      checkCacheStatus(currentMusic);
    }, 1000);

    let checkCount = 0;
    const maxChecks = 10;
    const interval = setInterval(() => {
      checkCount++;
      if (checkCount < maxChecks && currentMusic) {
        checkCacheStatus(currentMusic);
      } else {
        clearInterval(interval);
      }
    }, 2000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playing, currentMusic?.id]);

  useEffect(() => {
    const handleCacheCleared = () => {
      setIsCached(false);
      if (currentMusic) {
        checkCacheStatus(currentMusic);
      }
    };

    window.addEventListener('tenryu:cache-cleared', handleCacheCleared);
    return () => {
      window.removeEventListener('tenryu:cache-cleared', handleCacheCleared);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMusic]);
}
